import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private readonly _auth: AuthService) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        if (this._auth.isSignedIn) {
            request = this.addAuthorizationHeader(request);
        }

        return next.handle(request);
    }

    private addAuthorizationHeader(request: HttpRequest<unknown>) {
        const accessToken = this._auth.accessToken;
        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${accessToken}`
            }
        });
        return request;
    }
}
